import {
  Activity,
  Box,
  Edit3,
  Truck,
  Warehouse,
  X
} from 'lucide-react';

export const CATEGORY_OPTIONS = [
  { value: 'all', label: 'TODAS_LAS_CATEGORÍAS', icon: Box },
  { value: 'Ficción', label: 'FICCIÓN', icon: Box },
  { value: 'Ensayo', label: 'ENSAYO', icon: Box },
  { value: 'Técnico', label: 'TÉCNICO', icon: Box },
  { value: 'Clásico', label: 'CLÁSICO', icon: Box },
  { value: 'Cuento', label: 'CUENTO', icon: Box },
];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'TODOS_LOS_ESTADOS', icon: Activity },
  { value: 'warehouse', label: 'ALMACÉN', icon: Warehouse },
  { value: 'distributed', label: 'DISTRIBUIDO', icon: Truck },
  { value: 'out-of-stock', label: 'AGOTADO', icon: X },
  { value: 'printing', label: 'IMPRENTA', icon: Activity },
  { value: 'editorial', label: 'EDITORIAL', icon: Edit3 },
];
